import { llmModelDropdownOptions } from '@/libs/features/llm/display'

/**
 *
 */
export function setup() {
  return {
    llmModelDropdownOptions,
  }
}
